import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';

import PresenterBannerLayerSourceForm from 'components/BannerLayerSourceForm/PresentBannerLayerSourceForm/PresenterBannerLayerSourceForm';
import { PRESENTER_BANNER_FORM } from 'constants/ModalTypes';
import { clearModal } from '@shoflo/studio-redux/actions';
import ModalHeader from 'components/Modal/Header';
import { updateBanner } from 'actions/Broadcast';

const PresenterBannerForm = () => {
  const dispatch = useDispatch();
  const editModalTitle = 'Edit name card';

  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === PRESENTER_BANNER_FORM
  );
  const banner = useSelector(({ modal }) => modal && modal.initialValue);
  const templates = useSelector(({ bannerTemplates }) => bannerTemplates);

  const clearThisModal = () => dispatch(clearModal(PRESENTER_BANNER_FORM));

  const handleSubmit = layerSource => {
    dispatch(updateBanner(banner._id, layerSource));
    dispatch(clearModal(PRESENTER_BANNER_FORM));
  };

  return (
    <Modal isOpen={isOpen} toggle={clearThisModal} size={'md'}>
      <ModalHeader>{editModalTitle}</ModalHeader>
      <ModalBody>
        <PresenterBannerLayerSourceForm
          banner={banner}
          templates={templates}
          onSubmit={handleSubmit}
          onCancel={clearThisModal}
        />
      </ModalBody>
    </Modal>
  );
};

export default PresenterBannerForm;
